import React from 'react';
import _ from 'underscore';

import { formatDate } from 'utilities/common';
import Datagrid from 'ui/components/data/grid';

import LegsDetailItem from './legs.detail.item';

import {
  ActionDeparted,
  ActionArrived,
  ActionDelivered,
  ActionReceived,
  ActionDeleted,
} from '../actions';
import { Document } from './leg.documentation';
import { currencyFormat } from 'utilities/common';

const initialState = {
  action: '',
  carried: {
    weight: 0,
    quantity: 0,
  },
};

const LegsDetail = ({ manifest, legs, handleReload, onLegChanges, loading, privilege }) => {
  const [{ carried, action }, setState] = React.useState(initialState);

  const isNoaction = () => {
    return false

    // const x = _.filter(legs?.jobs, (j, i) => {
    //   return j.delivery_order.order.customer.name.includes('EDEN');
    // });

    // if (x.length > 0) {
    //   return false
    // } else {
    //   return (manifest?.moda?.land_freight?.driver?.user_id || manifest?.vendor?.name?.includes('envio') || (manifest?.vendor?.partner_id && manifest?.type !== 'forwarder') || (manifest?.vendor?.partner_id && manifest?.type === 'forwarder'))
    // }
  }

  const isShouldReceive = () => {
    if (legs?.is_receive) {
      const x = _.filter(legs?.jobs, (j, i) => {
        return j.status === 'delivered' || j.status === 'unreceived';
      });

      return x.length > 0;
    }

    return false;
  };

  const $handleResetAction = () => {
    setState((prevState) => ({ ...prevState, action: '' }));
  };

  const getETA = () => {
    if (!legs?.jobs) return '-';
    const eta = legs?.jobs[0]?.delivery_order?.shipment?.eta_at;

    return formatDate(eta);
  };

  const Action = () => {
    if (manifest?.status === 'new' && privilege) {
      return (
        <div className="card-footer-gray  border-top p-3">
          <span className="info fs-8 muted d-block text-center">
            Untuk memulai, silakan terbitkan dulu document ini!
          </span>
        </div>
      );
    }

    if (action !== '') {
      return null;
    }

    if (isNoaction()) {
      return null;
    }

    if (legs?.status === 'new' && privilege) {
      return (
        <div className="card-footer-gray row border-top p-3 m-0">
          <div className='col-6'>
            <button
              className="btn btn-sm btn-success w-100"
              onClick={() =>
                setState((prevState) => ({ ...prevState, action: 'departed' }))
              }
            >
              Mulai Perjalanan
            </button>
          </div>
          {(!legs?.is_receive) && (
            <div className='col-6'>
              <ActionDeleted
                manifest={manifest}
                legs={legs}
                handleClose={$handleResetAction}
                onSubmit={handleReload}
                onLegChanges={onLegChanges}
              />
            </div>
          )}
        </div>
      );
    }

    if (legs?.status === 'departed') {
      return (
        <div className="card-footer-gray row border-top p-3 m-0">
          <div className='col-6'>
            <button
              className="btn btn-sm btn-success w-100"
              onClick={() =>
                setState((prevState) => ({ ...prevState, action: 'arrived' }))
              }
            >
              Tiba di titik {legs?.type?.replace('_point', '')}
            </button>
          </div>
          {(!legs?.is_receive) && (
            <div className='col-6'>
              <ActionDeleted
                manifest={manifest}
                legs={legs}
                handleClose={$handleResetAction}
                onSubmit={handleReload}
                onLegChanges={onLegChanges}
              />
            </div>
          )}
        </div>
      );
    }

    return null;
  };

  React.useEffect(() => {
    if (!legs) return;

    let tw = _.reduce(
      legs?.jobs,
      function (sum, item) {
        if (item?.delivery_order?.shipment) {
          return sum + item?.delivery_order?.shipment?.total_weight;
        }
        return sum;
      },
      0
    );

    let tq = _.reduce(
      legs?.jobs,
      function (sum, item) {
        if (item?.delivery_order?.shipment) {
          return sum + item?.delivery_order?.shipment?.total_quantity;
        }
        return sum;
      },
      0
    );

    setState((prevState) => ({
      ...prevState,
      carried: {
        weight: tw,
        quantity: tq,
      },
      action: '',
    }));
  }, [legs]);

  if (!legs || loading) return null;

  return (
    <div className="card legs rounded-2 bg-white">
      <div className="card-header-gray p-3 border-bottom">
        <h3 className="card-title dx-card-title m-0 p-0">
          Detail {legs?.type?.replace('_point', '')} POINT
        </h3>
      </div>
      <div className="card-body p-3 pb-0 position-relative">
        <div className="mb-3">
          <Datagrid title={`Alamat ${legs?.type?.replace('_point', '')}`} />
          <div className="card card-form">
            <div className="card-body text-uppercase text-muted fs-9 p-2">
              <p>{legs?.location?.address}</p>

              <small>{`${legs?.location?.region?.district_name}, ${legs?.location?.region?.regency_name}, ${legs?.location?.region?.province_name}`}</small>
              <br />
              <small>
                CP: {legs?.location?.contact_person}{' '}
                {`/ ${legs?.location?.phone_number}`}
              </small>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6 ">
            <div className="datagrid">
              <Datagrid title="Jumlah Shipment" value={legs?.jobs?.length} />
              <Datagrid
                title="Total Muatan"
                value={`${carried?.quantity} Koli (${carried?.weight} KG)`}
              />
              {legs?.cod_value > 0 && (
                <Datagrid
                  title="COD"
                  value={currencyFormat(legs?.cod_value)}
                />
              )}
              {legs?.cod_receive > 0 && (
                <Datagrid
                  title="COD Diterima"
                  value={currencyFormat(legs?.cod_receive)}
                />
              )}
            </div>
          </div>
          <div className="col-6 ">
            <div className="datagrid">
              <Datagrid title="Status" value={legs?.status?.replace('_', ' ')} />
              {legs?.type === 'drop_point' && (
                <Datagrid title="Estimasi Kedatangan" value={getETA()} />
              )}
              {legs?.type === 'pickup' &&
                formatDate(legs?.loading_at) !== '-' && (
                  <Datagrid
                    title="Waktu Loading"
                    value={formatDate(legs?.loading_at)}
                  />
                )}
              {legs?.status === 'delivered' && (
                <Datagrid
                  title="Diterima Oleh"
                  value={legs?.received_by || '-'}
                />
              )}
              {legs?.status === 'delivered' && legs?.completed_note !== '' && (
                <Datagrid title="Catatan" value={legs?.completed_note || '-'} />
              )}
              {legs?.status === 'disputed' && (
                <Datagrid title="Catatan" value={legs?.disputed_note || '-'} />
              )}
            </div>
          </div>
          {((legs?.status === 'arrived' && legs?.type === 'pickup') ||
            ((legs?.status === 'delivered' || legs?.status === 'partial_delivered' || legs?.status === 'disputed') &&
              legs?.type === 'drop_point')) && (
            <div className="col-12">
              <Document
                manifest_id={manifest?.id}
                leg_id={legs?.id}
                privilege={privilege}
              />
            </div>
          )}
        </div>

        <LegsDetailItem
          manifest={manifest}
          legs={legs}
          onSubmit={handleReload}
        />
      </div>
      {privilege ? (
       <>
        {!isNoaction() && (
          <>
            {action === 'departed' && (
              <ActionDeparted
                manifest={manifest}
                legs={legs}
                handleClose={$handleResetAction}
                onSubmit={handleReload}
              />
            )}
            {action === 'arrived' && (
              <ActionArrived
                manifest={manifest}
                legs={legs}
                handleClose={$handleResetAction}
                onSubmit={handleReload}
              />
            )}
            {legs?.status === 'arrived' && legs?.type === 'drop_point' && (
              <ActionDelivered
                manifest={manifest}
                legs={legs}
                handleClose={$handleResetAction}
                onSubmit={handleReload}
                onLegChanges={onLegChanges}
              />
            )}
          </>
        )}
        {isShouldReceive() && (
          <ActionReceived
            manifest={manifest}
            legs={legs}
            onSubmit={handleReload}
          />
        )}
       </>
      ): null}
      <Action />

      {(isNoaction() && (manifest?.status !== 'new') && (!legs?.is_receive) && (legs?.status !== 'disputed' && legs?.status !== 'delivered' && legs?.status !== 'partial_delivered')) && (
        <div className="card-footer-gray border-top p-3">
          <ActionDeleted
            manifest={manifest}
            legs={legs}
            andleClose={$handleResetAction}
            onSubmit={handleReload}
            onLegChanges={onLegChanges}
          />
        </div>
      )}
    </div>
  );
};

export default LegsDetail;